import { GameApplication } from './engine/GameApplication';
import { SplashScene } from './scenes/SplashScene';
import { logger } from './utils/logger';

// Create the game application
const gameApp = new GameApplication({
  width: 1280,
  height: 720,
  backgroundColor: 0x08131a,
  antialias: true,
});

// Mount the game to the DOM
try {
  gameApp.mount('#game-container');
  logger.info('Game mounted successfully');

  // Store reference to game app for FPS metrics
  const app = gameApp.getApp() as unknown as {
    gameApp: typeof gameApp;
    sceneManager: ReturnType<typeof gameApp.getSceneManager>;
  };
  app.gameApp = gameApp;
  app.sceneManager = gameApp.getSceneManager();

  // Start with splash scene
  gameApp
    .getSceneManager()
    .changeScene(SplashScene, false)
    .then(() => {
      // Start the game loop
      gameApp.start();
      logger.info('Game started successfully');
    })
    .catch((error) => {
      logger.error('Failed to start scene:', error);
    });
} catch (error) {
  logger.error('Failed to start game:', error);
}

// Global error handler
window.addEventListener('error', (event) => {
  logger.error('Global error:', event.error);
});

// Handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  logger.error('Unhandled promise rejection:', event.reason);
});

// Expose game instance for debugging
if (import.meta.env.DEV) {
  (window as unknown as { gameApp: typeof gameApp }).gameApp = gameApp;
  logger.info('Game instance exposed as window.gameApp for debugging');
}
